import React from "react"
import Articles from "./Articles"
import RoundedCard from "../product-marketing/RoundedCard"

type Props = {
  category: string
  tag?: string
}

const CategoryPreview = ({ category, tag }: Props) => (
  <RoundedCard className="de-sidebar category-preview top-accent">
    <Articles
      category={category}
      limit={4}
      titlePrefix="Latest"
      tag={tag?.toLowerCase()}
    />
  </RoundedCard>
)

export default CategoryPreview
